export default __webpack_public_path__ + "static/media/crossIcon.ba2caa46.svg";